import axios from '@service'
import { SAVE_CASH_PAYMENT_RECORD } from './api'
import { HTTP_ERR_SUCCESS } from '@constant/api_status'
import { ERROR_DEFAULT_HTTP_REQUEST_FAIL } from '@constant/error'

// 保证金缴纳信息
export default async function saveCashPaymentRecordService(payload = {}, config = {}) {
    const param = {
        ...SAVE_CASH_PAYMENT_RECORD,
        ...config,
        data: payload
    }

    const { data } = await axios(param)

    if (data.code === HTTP_ERR_SUCCESS) {
        return data.result || {}
    } else {
        throw new Error(data.errorMessage || ERROR_DEFAULT_HTTP_REQUEST_FAIL)
    }
}
